export default __webpack_public_path__ + "static/media/right.2b1e971d.svg";